module.exports = __webpack_public_path__ + "static/media/figtree-latin-ext-800.eafb88d8.woff2";